import request from '@/utils/request'

const news = {}

// news
news.getList = params => request({
    url: `/ops/public/getnews`,
    method: 'GET',
    params: params
})

export default news